"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isComponentClass = isComponentClass;
exports.isReactMemo = isReactMemo;
exports["default"] = exports.cookie = void 0;

function isComponentClass(Component) {
  return Component.prototype && Component.prototype.render;
}

function isReactMemo(Component) {
  return typeof Component !== 'function' && !!Component['$$typeof'];
}

var cookie = {
  get: function get(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].replace(/^\s+/, '');

      if (c.indexOf(nameEQ) == 0) {
        var ret;

        try {
          ret = decodeURIComponent(c.substring(nameEQ.length, c.length));
        } catch (e) {
          ret = unescape(c.substring(nameEQ.length, c.length));
        }

        return ret;
      }
    }
  }
};
exports.cookie = cookie;
var _default = {
  isComponentClass: isComponentClass
};
exports["default"] = _default;